import { render, staticRenderFns } from "./omt-slider.vue?vue&type=template&id=26763ee4&scoped=true&"
import script from "./omt-slider.vue?vue&type=script&lang=js&"
export * from "./omt-slider.vue?vue&type=script&lang=js&"
import style0 from "./omt-slider.vue?vue&type=style&index=0&id=26763ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26763ee4",
  null
  
)

export default component.exports